import React, { useEffect, useState } from "react";
import { api, whatsappLink } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Copy, MessageCircle } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const LANGS = [
  { code: "en", label: "English" },
  { code: "nl", label: "Nederlands" },
  { code: "fr", label: "Français" },
];

export default function Templates() {
  const [items, setItems] = useState([]);
  const [lang, setLang] = useState("en");

  useEffect(() => {
    api.get(`/templates?lang=${lang}`).then((r) => setItems(r.data));
  }, [lang]);

  const copy = (body) => {
    navigator.clipboard.writeText(body);
    toast.success("Copied to clipboard");
  };

  return (
    <div>
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-[#1B3A6B]">Message Templates</h1>
          <p className="text-sm text-slate-500 mt-1">Copy or send quickly via WhatsApp. Replace placeholders before sending.</p>
        </div>
        <div className="w-44">
          <Select value={lang} onValueChange={setLang}>
            <SelectTrigger data-testid="templates-lang"><SelectValue /></SelectTrigger>
            <SelectContent>{LANGS.map((l) => <SelectItem key={l.code} value={l.code}>{l.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <div className="mt-6 grid lg:grid-cols-2 gap-4">
        {items.map((tpl) => (
          <div key={tpl.id} className="bg-white rounded-xl ring-1 ring-slate-200 p-5" data-testid={`template-${tpl.id}`}>
            <div className="flex items-center justify-between">
              <h3 className="font-heading font-semibold text-[#0F172A]">{tpl.name}</h3>
              <div className="flex gap-1">
                <Button size="sm" variant="ghost" onClick={() => copy(tpl.body)} data-testid={`template-copy-${tpl.id}`}>
                  <Copy className="w-4 h-4" />
                </Button>
                <a href={whatsappLink(tpl.body)} target="_blank" rel="noopener noreferrer">
                  <Button size="sm" variant="ghost"><MessageCircle className="w-4 h-4 text-[#5BA83F]" /></Button>
                </a>
              </div>
            </div>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed whitespace-pre-line bg-slate-50 rounded-md p-3 font-mono text-[12px]">{tpl.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
